import { Input, Layout, Typography } from "antd";
import { Content, Footer } from "antd/lib/layout/layout";
import React, { ChangeEvent, useEffect, useState } from "react";
import * as S from "./styles";
import { SearchOutlined } from "@ant-design/icons";
import { CarrierName } from "../ShippingPreferencesSection";
import ShippingPreferencesDrawerTable from "./ShippingPreferencesDrawerTable";
const { Text } = Typography;

interface ShippingDrawerProps {
  allCarriers: CarrierName[];
  onClose: () => void;
  isDrawerVisible: boolean;
  removePreference: (carrierName: CarrierName) => void;
  addCarrierFilter: (carrierName: string) => void;
  selectChange: (selectedValue: string, carrierName: string) => void;
  whitelisted: string[];
  blacklisted: string[];
}

const ShippingPreferencesDrawer: React.FC<ShippingDrawerProps> = ({
  allCarriers,
  onClose,
  isDrawerVisible,
  removePreference,
  selectChange,
  addCarrierFilter,
  whitelisted,
  blacklisted,
}) => {
  const [drawerCarriers, setDrawerCarriers] = useState<CarrierName[]>(allCarriers);

  useEffect(() => {
    setDrawerCarriers(allCarriers);
  }, [allCarriers]);

  const filterDrawerCarriers = (searchQuery: string) => {
    if (!searchQuery) {
      setDrawerCarriers(allCarriers);
    } else {
      const filteredCarriers = allCarriers.filter((c) =>
        c.carrierName.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())
      );
      setDrawerCarriers(filteredCarriers);
    }
  };

  return (
    <S.Drawer
      headerStyle={{ padding: 24 }}
      title="All Carriers"
      placement="right"
      onClose={onClose}
      visible={isDrawerVisible}
    >
      <Layout style={{ minHeight: "100vh" }}>
        <div style={{ margin: "20px 10px 20px 10px" }}>
          <Text type="secondary">Search Carrier</Text>
          <Input
            suffix={<SearchOutlined />}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              filterDrawerCarriers(e.target.value);
            }}
            placeholder="Search Carrier"
          ></Input>
        </div>
        <Content>
          <ShippingPreferencesDrawerTable
            drawerCarriers={drawerCarriers}
            removePreference={removePreference}
            selectChange={selectChange}
            addCarrierFilter={addCarrierFilter}
            whitelisted={whitelisted}
            blacklisted={blacklisted}
          ></ShippingPreferencesDrawerTable>
        </Content>
        <Footer style={{ position: "sticky", margin: 0, padding: 10, bottom: "0" }}>
          <b>{`${allCarriers.length}`}</b>
          {` results in total`}
        </Footer>
      </Layout>
    </S.Drawer>
  );
};

export default ShippingPreferencesDrawer;
